module.exports = __webpack_public_path__ + "img/vob.ec5aed34.svg";